import { Component, OnInit } from '@angular/core';
import { ZoonosesService, User } from '../zoonoses.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public user = new User('', '');
  public errorMsg = '';

  constructor(
      private zoonosesService: ZoonosesService) {}

  login() {
      if (!this.zoonosesService.login(this.user)){
          this.errorMsg = 'Failed to login';
      }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/bdegroot/Projects/vgtropics-ph/src/app/login/login.component.ts